import * as React from 'react';
import styled from '@emotion/styled';
import Img from 'gatsby-image';

import { mainColor as MAIN_COLOR } from '../../styles';

const Wrapper = styled.div`
  padding: 2em;
  width: 620px;
  max-width: 95vw;
  margin-bottom: 2em;
  border: 1px solid #e9ebed;
  border-radius: 5px;
  position: relative;
  min-height: 150px;
  color: #696969;
  overflow: hidden;

  & > div {
    position: absolute;
  }
`;

const ContentWrapper = styled.div`
  width: 55%;
  height: 100%;
  right: 0;
  top: 0;
  padding: 15px;

  h3 {
    position: relative;
    padding: 6px 0 12px;
    margin-bottom: 20px;

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0px;
      width: 60px;
      height: 4px;
      background-color: ${MAIN_COLOR};
    }
  }

  p:nth-of-type(1) {
    font-size: 1.6rem;
  }
`;

const ContentContainer = styled.div``;

const Layer1 = styled.div`
  width: 83%;
  height: 300%;
  top: -150%;
  right: -20%;
  background-color: #fff;
  transform: rotate(-25deg);
`;

const Layer2 = styled.div`
  width: 83%;
  height: 300%;
  top: -50%;
  right: -20%;
  background-color: ${MAIN_COLOR};
  transform: rotate(25deg);
`;

const ImageWrapper = styled.div`
  height: 100%;
  width: 60%;
  left: 0;
  top: 0;
`;

const Component: React.FCX<{ node: any }> = ({ node }) => (
  <Wrapper>
    <ImageWrapper>
      {Boolean(node.frontmatter.cover) && (
        <Img fluid={node.frontmatter.cover.childImageSharp.fluid} alt={node.frontmatter.title} />
      )}
    </ImageWrapper>
    <Layer2></Layer2>
    <Layer1></Layer1>
    <ContentWrapper>
      <ContentContainer>
        <h3>{node.frontmatter.title}</h3>
        <p>{node.frontmatter.date}</p>
        <p>{node.excerpt}</p>
      </ContentContainer>
    </ContentWrapper>
  </Wrapper>
);

export default Component;
